import React, { useState } from 'react';
import './css/BannerImage.css';

const BannerImage = ({
  src,
  alt,
  className = '',
  style = {},
  imageStyle = {},
  fallbackText = 'Banner unavailable'
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={`banner-image-shell ${className}`.trim()} style={style}>
      {!isLoaded && !hasError && <div className="banner-image-skeleton" aria-hidden="true" />}

      {!hasError && (
        <img
          src={src}
          alt={alt}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          style={{ ...imageStyle, display: isLoaded ? 'block' : 'none' }}
        />
      )}

      {hasError && <div className="banner-image-fallback">{fallbackText}</div>}
    </div>
  );
};

export default BannerImage;
